import { render, staticRenderFns } from "./ArrowDownBlackIcon.vue?vue&type=template&id=7b4175d8"
import script from "./ArrowDownBlackIcon.vue?vue&type=script&lang=js"
export * from "./ArrowDownBlackIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports